<template>
  <div>
    <a-card :bordered="false" class="text-live">
      <div class="increase-edit-padding">
        <a-spin :spinning="loading">
          <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
        </a-spin>
        <div v-if="!loading">
          <div>
            <customer-summary v-if="basicData" :initData="basicData" :countryList="countryList"></customer-summary>
          </div>
          <a-tabs type="card" :defaultActiveKey="'1'" @change="handleTabChange">
            <a-tab-pane key="1" tab="Basic" :forceRender="true">
              <cdb-basic ref="basicComponent" v-if="basicData && emergencyContact" :initData="basicData" :initEmergencyContact="emergencyContact" :countryList="countryList"></cdb-basic>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Tour Info" :forceRender="true">
              <customer-tour ref="tourComponent" v-if="tourData" :tourData="tourData" :record="record" @change="handleCustomerTourChange"></customer-tour>
            </a-tab-pane>
            <a-tab-pane  key="3" tab="Coupon" :forceRender="true">
              <!-- 新增的的时候不出现 v-if="editData && editData.id" -->
              <customer-coupon v-if="record && record !== ''" :record="record"></customer-coupon>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top: 20px;" v-if="record && record !== ''">
      <cdb-logs :customerId="record.id" ref="cdbLogs"></cdb-logs>
    </a-card>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="saving" v-if="!editMode" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import moment from 'moment'
import FooterToolBar from '@/components/FooterToolbar'
import CdbBasic from './components/CdbCustomerBasic'
import CustomerSummary from './components/CdbCustomerSummary'
import CustomerTour from './components/CdbCustomerTour'
import CustomerCoupon from './components/CdbCustomerCoupon'
import CustomerApi from '@/api/api-cdb-customer'
import CountryApi from '@/api/basicdata/api-country'
import pick from 'lodash.pick'
import CdbLogs from './components/CdbCustomerLogs'


const getDefaultFormData = () => {
  return { id: null, firstName: null, lastName: null, preferToBeCalled: null, fullName: null,  middleName: null, gender: 'M', birthday: null, companyCode: 'signet' }
}

export default {
  name: 'CdbCustomerEdit',
  components: {
    FooterToolBar,
    CdbBasic,
    CustomerSummary,
    CustomerTour,
    CustomerCoupon,
    CdbLogs
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    },
    // 是否直接链接进入编辑模式
    editMode: {
      type: [Boolean],
      default: false
    }
  },
  data () {
    return {
      saving: false,
      loading: false,
      editData: this.tourData,
      // 基础数据
      basicData: getDefaultFormData(),
      // 行程相关数据
      tourData: null,
      // 紧急联系人
      emergencyContact: null,
      countryList: [],
      activeTabKey: '1',
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      // 加载国家数据
      const resCountry = await CountryApi.list()
      const countryList = resCountry.data
      this.countryList = countryList

      this.basicData = null
      const record = this.record
      let formData = null
      let tourData = null
      let emergencyContact = {firstName: null, lastName: null, phoneCountryCode: null, phoneCountryCallingCode: null, phoneNumber: null, phoneExt: null, email: null, realationShip: 'Z'}
      if (record === '') {
        // 新增 初始化默认值
        formData = getDefaultFormData()
        tourData = { id: null, mealsRequest: null, specialRequest: null, specialNote:null,roomPreferred:null }
      } else {
        // 修改 加载后台完整数据
        const res = await CustomerApi.detail(record.id)
        const resData = res.data
        formData = pick(resData, ['id', 'fullName', 'firstName', 'lastName', 'middleName', 'gender', 'preferToBeCalled', 'referralBy', 'referralByOthers', 
        'birthday', 'title', 'phoneCountryCode', 'phoneCountryCallingCode', 'phoneNumber', 'phoneExt',
        'email', 'languages', 'nationalBackground', 'ethnicitiesId', 'companyCode', 'addressList', 'passportList', 'customerCode', 'membership', 'contactList'])
        tourData = pick(resData, ['id', 'mealsRequest', 'specialRequest', 'specialNote', 'roomPreferred' ])
        if(resData.emergencyContact) {
          emergencyContact = resData.emergencyContact
        }
      }
      this.basicData = formData
      this.tourData = tourData
      this.emergencyContact = emergencyContact
      this.loading = false
    },
    handleTabChange (key) {
      this.activeTabKey = key
    },
    handleGoBack () {
      this.loading = true
      this.$emit('onGoBack')
    },
    async handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      // 读取basic内容
      const basicComponentPromise = this.$refs.basicComponent.validateBasicForm
      let formData = null
      try {
        formData = await basicComponentPromise()
      } catch (e) {
        if (e) {
          console.log('warnning:', e.message)
        }
        this.saving = false
        return
      }
      formData.birthday = moment(formData.birthday).format('YYYY-MM-DD')
      // 读取tour内容
      if (this.$refs.tourComponent && this.$refs.tourComponent.validateTourForm) {
        const tourComponentPromise = this.$refs.tourComponent.validateTourForm
        const tourFormData = await tourComponentPromise()
        formData.mealsRequest = tourFormData.mealsRequest
        formData.specialRequest = tourFormData.specialRequest
        formData.specialNote = tourFormData.specialNote
        formData.roomPreferred = tourFormData.roomPreferred
      }
      // 添加
      if (formData.id === null) {
        CustomerApi.add(formData).then(res => {
          if (!this.mixinProcessHasBizErrorNotification(res)) {
            this.mixinProcessSuccessNotification('Save successfully !')
            this.handleGoBack()
          }
        }).finally(() => {
          this.saving = false
        })
      }
      // 修改
      if (formData.id !== null) {
        CustomerApi.update(formData.id, formData).then(res => {
          if (!this.mixinProcessHasBizErrorNotification(res)) {
            this.mixinProcessSuccessNotification('Update successfully !')
            if (!this.editMode) {
              this.handleGoBack()
            }
          }
        }).finally(() => {
          this.saving = false
        })
      }
    },
    // 处理CustomerTour变化
    handleCustomerTourChange () {
      this.$refs.cdbLogs.loadInitData()
    }
  },
  watch: {
    record() {
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-tabs {
  overflow: visible;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-advanced-search-form {
  padding-top: 20px;
}
::v-deep .ant-advanced-search-form .ant-form-item {
  margin-bottom: 0;
}
::v-deep .ant-col .ant-form-item-label {
  line-height: 30px;
}

</style>